module.exports = __webpack_public_path__ + "static/media/fechandoDreno.7382bae3.jpg";